<script>
import BaseSubscriptionPlanFeatureList
  from "%/dynamic-component-editor/standard-components/subscription-card/BaseSubscriptionPlanFeatureList.vue";
import IconOptions from "%/dynamic-component-editor/bundles/icon-options";

export default {
  name: "SubscriptionPlanIncludedFeatures",
  elementPanelSettings: {
    displayName: "Included Features",
    displayIcon: "check-circle",
    elementGroup: "subscriptionElements",
    elementType: "element",
  },
  extends: BaseSubscriptionPlanFeatureList,
  optionBundles: [
    new IconOptions({
      "default.icon": "material-symbols:check-circle",
      "default.icon-variant": "primary",
    }),
  ],
  computed: {
    featureTexts() {
      return this.entity.includedFeatures;
    },
  },
};
</script>
